import type { ComponentProps } from 'react'

import { GoodUnitedIcon, SubscriberMessengerIcon } from '@/components/icons/goodunited-icons'

import {
    FacebookLogoIcon,
    InstagramLogoIcon,
    MessengerLogoIcon,
    PersonSimpleRunIcon,
    UserMinusIcon
} from '@/components/icons/icon-set'

/*
 * GoodUnited source icons. One icon per acquisition or revenue source so legends, tracks,
 * accordions and tables always show the same mark for the same source.
 * Revenue sources that are Facebook fundraisers (general, birthdays, other) carry the Facebook mark,
 * as in the Figma revenue breakdown. subscribers and unsubscribes are the two totals that sit beside
 * the sources in subscriber legends.
 */
export type SourceKey =
    | 'facebook'
    | 'messenger'
    | 'platform'
    | 'challenges'
    | 'instagram'
    | 'birthdays'
    | 'general'
    | 'other'
    | 'subscribers'
    | 'unsubscribes'

const icons = {
    facebook: FacebookLogoIcon,
    messenger: MessengerLogoIcon,
    platform: GoodUnitedIcon,
    challenges: PersonSimpleRunIcon,
    instagram: InstagramLogoIcon,
    birthdays: FacebookLogoIcon,
    general: FacebookLogoIcon,
    other: FacebookLogoIcon,
    subscribers: SubscriberMessengerIcon,
    unsubscribes: UserMinusIcon
}

/* Legend and data keys that name a source under another word ('total' is the subscriber total). */
const ALIASES: Record<string, SourceKey> = {
    total: 'subscribers'
}

/* The source for a data key, or undefined when the key is not a source. */
export const sourceKey = (key: string): SourceKey | undefined => {
    if (key in icons) return key as SourceKey

    return ALIASES[key]
}

export function SourceIcon({ source, ...props }: ComponentProps<'svg'> & { source: SourceKey }) {
    const Icon = icons[source]

    return <Icon aria-hidden='true' {...props} />
}
